export default __webpack_public_path__ + "static/media/onlineres.f9898cdd.PNG";